// 학습 플레이어 타입과 파라미터를 관리하는 클래스
// 학습 플레이어 타입에 관련된 클래스는 모두 이 클래스를 상속받는다.
import qs from "qs";

class PlayerInfo {
    PLAYER_URL = "/playerMain";
    PLAYER_TYPE;

    info;

    constructor(playerType, info) {
        this.PLAYER_TYPE = playerType;
        this.info = info;

        console.log(this.info);
    }

    getUrl() {
        if (this.PLAYER_TYPE !== "SINGLE_VOD") {
            return this.PLAYER_URL + "?" + qs.stringify({ PLAYER_TYPE: this.PLAYER_TYPE, ...this.info });
        }
        return this.info?.PLAYER_URL || "";
    }

    gotoPlayer(history) {
        const url = this.getUrl();

        history.push(url);
    }
}

export default PlayerInfo;
